import React from "react";
import Reveal from "./Reveal";

interface SectionHeaderProps {
  number: string;
  title: string;
  highlight?: string;
  subtitle?: string;
  centered?: boolean;
  /** Für dunkle Sektionen (helle Schrift) */
  onDark?: boolean;
}

const SectionHeader = ({ number, title, highlight, subtitle, centered = true, onDark = false }: SectionHeaderProps) => {
  return (
    <Reveal className={`mb-12 md:mb-16 ${centered ? "text-center" : "text-left"}`}>
      {/* Editoriale Kicker-Zeile mit Abschnittsnummer */}
      <div className={`flex items-center gap-3 mb-5 ${centered ? "justify-center" : ""}`}>
        <span className={`h-px w-8 ${onDark ? "bg-flame-soft/70" : "bg-flame/70"}`} aria-hidden="true" />
        <span
          className={`font-mono text-sm font-bold tracking-[0.35em] ${
            onDark ? "text-flame-soft" : "text-flame"
          }`}
        >
          {number}
        </span>
        <span className={`h-px w-8 ${onDark ? "bg-flame-soft/70" : "bg-flame/70"} ${centered ? "" : "flex-1 max-w-16"}`} aria-hidden="true" />
      </div>

      <h2
        className={`text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight ${
          onDark ? "text-white" : "text-navy"
        }`}
      >
        {title}{" "}
        {highlight && (
          <span className={onDark ? "text-accent" : "text-primary"}>
            {highlight}
          </span>
        )}
      </h2>

      {/* Subtitle */}
      {subtitle && (
        <p
          className={`mt-5 text-lg md:text-xl leading-relaxed max-w-3xl ${
            centered ? "mx-auto" : ""
          } ${onDark ? "text-white/70" : "text-muted-foreground"}`}
        >
          {subtitle}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeader;
